export default __webpack_public_path__ + "static/media/equipment.9b7056a6.svg";